var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.dateRanges,"item-text":"name","item-value":"id","label":_vm.$t('dateRangeSelect.label'),"hide-details":_vm.hideDetails,"solo":_vm.solo,"flat":_vm.flat,"filled":_vm.filled},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }